import { AGENT_USER_ID, AGENT_NAME } from '@/const/constants'

// The built-in agent is shown as "Plate" everywhere. Its username is the lowercase handle
// "plate", so name displays that key off `username` would otherwise render it inconsistently
// ("plate" vs "Plate" vs "Agent"). Use this for any member name shown in the UI.
export function getMemberDisplayName(
    member: { userId: string; username?: string } | null | undefined,
): string {
    if (!member) return ''
    return member.userId === AGENT_USER_ID ? AGENT_NAME : (member.username ?? '')
}
